import React from 'react';
import { motion } from 'framer-motion';
import { COMPANY_LEGAL } from '../config/companyLegalIdentity.generated';
import Seo from '../components/Seo';
import { seo } from '../seo/seoData';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-black pt-20" data-testid="mentions-legales-page">
          <Seo {...seo.mentionsLegalesLegacy} />
      <section className="py-24 md:py-32">
        <div className="max-w-[800px] mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-white tracking-tight mb-12">
              Mentions légales
            </h1>

            <div className="prose prose-invert max-w-none space-y-8">
              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Éditeur du site</h2>
                <p className="text-neutral-400">
                  Raison sociale : {COMPANY_LEGAL.legalName} ({COMPANY_LEGAL.legalForm})<br />
                  Marque exploitée : {COMPANY_LEGAL.brand}<br />
                  Capital social : {COMPANY_LEGAL.shareCapital}<br />
                  Siège social : {COMPANY_LEGAL.address.street}, {COMPANY_LEGAL.address.postalCode} {COMPANY_LEGAL.address.city}, {COMPANY_LEGAL.address.country}<br />
                  SIREN : {COMPANY_LEGAL.siren}<br />
                  SIRET : {COMPANY_LEGAL.siret}<br />
                  {COMPANY_LEGAL.rcs}<br />
                  N° TVA intracommunautaire : {COMPANY_LEGAL.vat}<br />
                  Code APE/NAF : {COMPANY_LEGAL.apeNaf}<br />
                  Téléphone : {COMPANY_LEGAL.phone}<br />
                  Email : {COMPANY_LEGAL.email}<br />
                  Directeur de la publication : {COMPANY_LEGAL.directorOfPublication}
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Activité</h2>
                <p className="text-neutral-400">
                  Transport de personnes par voiture de transport avec chauffeur (VTC).
                  Exploitation soumise à la réglementation en vigueur.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Hébergement</h2>
                <p className="text-neutral-400">
                  {COMPANY_LEGAL.host.name}<br />
                  {COMPANY_LEGAL.host.street}<br />
                  {COMPANY_LEGAL.host.postalCode} {COMPANY_LEGAL.host.city}, {COMPANY_LEGAL.host.country}
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Propriété intellectuelle</h2>
                <p className="text-neutral-400">
                  L'ensemble des contenus présents sur ce site (textes, images, logos, éléments graphiques) 
                  sont la propriété exclusive de Black Matte ou font l'objet d'une autorisation d'utilisation.
                  Toute reproduction, représentation, modification ou exploitation non autorisée est interdite.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Responsabilité</h2>
                <p className="text-neutral-400">
                  Black Matte s'efforce d'assurer l'exactitude des informations publiées sur ce site.
                  Toutefois, Black Matte ne peut garantir l'exactitude, la précision ou l'exhaustivité 
                  des informations mises à disposition.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Contact</h2>
                <p className="text-neutral-400">
                  Pour toute question relative aux mentions légales, vous pouvez nous contacter :<br />
                  Téléphone : 09 39 24 23 20<br />
                  WhatsApp : 07 66 30 15 03
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default MentionsLegalesPage;
